import localDB from "./localDB";

let GLOBAL = require('./globals');

const ExpenseDetailData = {
    async list(id) {
        let response = await fetch(`${GLOBAL.BASE_URL}api/expenses-detail/${id}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async delete(id, res) {
        await fetch(`${GLOBAL.BASE_URL}api/expense-detail/${id}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch(() => res(null));
    },
    async add(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/expenses-detail/${data.expense}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((error) => res(null));
    },
};

export default ExpenseDetailData;


// WEBPACK FOOTER //
// ./src/data/ExpenseDetailData.js